import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { timer } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class TimeHelper {
  static readonly updatingNow = signal(Date.now());

  readonly ONE_MINUTE = 60000;
  readonly destroyRef = inject(DestroyRef);

  initialize() {
    // wait for the next minute to update the time, so the trigger will always be at the start of the minute
    const now = new Date();
    const msUntilNextMinute = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();

    timer(msUntilNextMinute, this.ONE_MINUTE)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => TimeHelper.updatingNow.set(Date.now()));
  }
}
